import { useHasValidatedStopReasons } from '@folio/utils/useHasValidatedStopReasons';
import { STOP_AWAITING_VALIDATION, useKorintModuleConfig } from 'korint-sdk/react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PolicyTable } from '../../components/module-elements/PolicyTable/PolicyTable';

const STATUS_FIELDS = ['policyStatus', 'policyCustomStatus'] as const;

export function PortfolioModule() {
  const { t } = useTranslation();
  const portfolio = useKorintModuleConfig('portfolio');
  const hasValidatedStopReasons = useHasValidatedStopReasons();

  const filtersConfig = useMemo(() => {
    if (!hasValidatedStopReasons) {
      return portfolio.filtersConfig;
    }

    const withOption = { ...portfolio.filtersConfig };
    for (const field of STATUS_FIELDS) {
      const config = withOption[field];
      if (config?.type !== 'select' || config.options.includes(STOP_AWAITING_VALIDATION)) {
        continue;
      }
      withOption[field] = { ...config, options: [...config.options, STOP_AWAITING_VALIDATION] };
    }
    return withOption;
  }, [portfolio.filtersConfig, hasValidatedStopReasons]);

  return (
    <PolicyTable
      title={t('policyTable.portfolio.title')}
      filtersConfig={filtersConfig}
      baseFilters={portfolio.baseFilters}
      expandCustomers={portfolio.expandCustomers}
      expandBrokerageFirm={portfolio.expandBrokerageFirm}
      expandAssets={portfolio.expandAssets}
      columns={portfolio.columns}
    />
  );
}
